import React, { createContext, useContext, useState, useEffect, ReactNode, useMemo } from 'react';
import invariant from 'invariant';

import { DEFAULT_CALENDAR_VIEW } from '..';
import { useCalendarSettings } from './CalendarSettingsContext';

interface CalendarViewContextType {
	currentView: string;
	setCurrentView: React.Dispatch<React.SetStateAction<string>>;
}

const CalendarViewContext = createContext<CalendarViewContextType | undefined>(undefined);

export const CalendarViewProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
	const { settings } = useCalendarSettings();

	const [currentView, setCurrentView] = useState<string>(settings?.defaultView || DEFAULT_CALENDAR_VIEW);

	useEffect(() => {
		setCurrentView(settings?.defaultView || DEFAULT_CALENDAR_VIEW);
	}, [settings]);

	const contextValue = useMemo(() => ({ currentView, setCurrentView }), [currentView, setCurrentView]);

	return <CalendarViewContext.Provider value={contextValue}>{children}</CalendarViewContext.Provider>;
};

export const useCalendarView = (): CalendarViewContextType => {
	const context = useContext(CalendarViewContext);

	invariant(context, 'useCalendarView must be used within a CalendarViewProvider');

	return context;
};
